/* mb-gallery-peek.js
 * Mobile PDP gallery → Swiper loop carousel with a peek of the previous
 * AND next photo on both sides + dots, like the reference. On mobile
 * (<=749px) we restructure Dawn's media list into a Swiper slider with
 * loop:true + centeredSlides:true so EVERY photo (incl. the first) shows
 * a peek on both sides. Native touch-swipe + clickable dots. Desktop
 * (>=750px) keeps Dawn's own gallery untouched (Swiper is torn down).
 */
(function () {
  'use strict';
  var MOBILE = '(max-width: 749px)';
  function isMobile() { return window.matchMedia(MOBILE).matches; }
  function items(list) { return Array.prototype.slice.call(list.querySelectorAll('.product__media-item')); }

  function build(list) {
    if (list.__mbSwiperInst || typeof window.Swiper !== 'function') return;
    var its = items(list);
    if (its.length < 2) return;

    list.classList.add('swiper-wrapper');
    its.forEach(function (it) { it.classList.add('swiper-slide'); });

    var swEl = document.createElement('div');
    swEl.className = 'swiper mb-gal-swiper';
    list.parentNode.insertBefore(swEl, list);
    swEl.appendChild(list);

    function svg(p) { return '<svg viewBox="0 0 24 24" width="19" height="19" aria-hidden="true">' + p + '</svg>'; }
    var prev = document.createElement('button');
    prev.type = 'button'; prev.className = 'mb-gal-nav mb-gal-prev'; prev.setAttribute('aria-label', 'Vorige foto');
    prev.innerHTML = svg('<path d="M15 5 L8 12 L15 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>');
    var next = document.createElement('button');
    next.type = 'button'; next.className = 'mb-gal-nav mb-gal-next'; next.setAttribute('aria-label', 'Volgende foto');
    next.innerHTML = svg('<path d="M9 5 L16 12 L9 19" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>');
    var zoom = document.createElement('button');
    zoom.type = 'button'; zoom.className = 'mb-gal-zoom'; zoom.setAttribute('aria-label', 'Vergroot foto');
    zoom.innerHTML = svg('<circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20 L15.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/>');
    zoom.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var a = swEl.querySelector('.swiper-slide-active') || swEl.querySelector('.swiper-slide');
      var b = a && a.querySelector('.product__media-toggle, modal-opener button');
      if (b) b.click();
    });
    swEl.appendChild(prev); swEl.appendChild(next); swEl.appendChild(zoom);

    var pag = document.createElement('div');
    pag.className = 'swiper-pagination mb-gal-pag';
    swEl.appendChild(pag);
    list.__mbSwiperEl = swEl;

    list.__mbSwiperInst = new window.Swiper(swEl, {
      loop: true,
      centeredSlides: true,
      slidesPerView: 'auto',
      spaceBetween: 0,
      autoHeight: true,
      watchOverflow: true,
      navigation: { nextEl: next, prevEl: prev },
      pagination: { el: pag, clickable: true }
    });
  }

  function teardown(list) {
    if (list.__mbSwiperPoll) { window.clearInterval(list.__mbSwiperPoll); list.__mbSwiperPoll = null; }
    if (list.__mbSwiperInst) {
      try { list.__mbSwiperInst.destroy(true, true); } catch (e) {}
      list.__mbSwiperInst = null;
    }
    var swEl = list.__mbSwiperEl;
    if (swEl && swEl.parentNode) {
      var pag = swEl.querySelector('.mb-gal-pag');
      if (pag) pag.remove();
      swEl.parentNode.insertBefore(list, swEl);
      swEl.remove();
    }
    list.__mbSwiperEl = null;
    list.classList.remove('swiper-wrapper');
    items(list).forEach(function (it) { it.classList.remove('swiper-slide'); });
  }

  function sync(list) {
    if (isMobile()) {
      if (!list.__mbSwiperInst) {
        if (typeof window.Swiper === 'function') {
          build(list);
        } else {
          /* Load-order race: mb-swiper.js may not have defined window.Swiper
             yet when sync first runs on mobile. Run a self-clearing
             setInterval poll (~50ms x up to 40 = ~2s) and re-run sync once
             Swiper is ready, so the gallery can never be left permanently
             un-built. Guarded by __mbSwiperPoll so resize/section:load can
             never stack multiple intervals. */
          if (!list.__mbSwiperPoll) {
            var tries = 0;
            list.__mbSwiperPoll = window.setInterval(function () {
              tries++;
              if (typeof window.Swiper === 'function' || tries > 40 || !isMobile()) {
                window.clearInterval(list.__mbSwiperPoll);
                list.__mbSwiperPoll = null;
                sync(list);
              }
            }, 50);
          }
        }
      }
    } else if (list.__mbSwiperInst) {
      teardown(list);
    }
  }

  /* Single ZOOM button: a white magnifier circle overlaid
     bottom-right ON the centred photo (the CSS-only scroll-snap gallery has no
     zoom of its own). Click opens Dawn's lightbox (product-modal) for whichever
     slide is currently centred. Lightweight: one button + one handler, no DOM
     restructuring; CSS hides it on desktop. */
  function addZoom(list) {
    if (list.__mbZoomBtn) return;
    if (items(list).length < 1) return;
    var host = list.parentElement; /* slider-component (position:relative) */
    if (!host) return;
    var zoom = document.createElement('button');
    zoom.type = 'button';
    zoom.className = 'mb-gal-zoom2';
    zoom.setAttribute('aria-label', 'Vergroot foto');
    zoom.innerHTML = '<svg viewBox="0 0 24 24" width="20" height="20" aria-hidden="true"><circle cx="10.5" cy="10.5" r="6.5" fill="none" stroke="currentColor" stroke-width="2"/><path d="M20 20 L15.5 15.5" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    zoom.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var arr = items(list);
      if (!arr.length) return;
      var listRect = list.getBoundingClientRect();
      var center = listRect.left + listRect.width / 2;
      var best = arr[0], bestD = Infinity;
      arr.forEach(function (it) {
        var r = it.getBoundingClientRect();
        var d = Math.abs((r.left + r.width / 2) - center);
        if (d < bestD) { bestD = d; best = it; }
      });
      var b = best && best.querySelector('.product__media-toggle, modal-opener button, .product__modal-opener button');
      if (b) b.click();
    });
    list.__mbZoomBtn = zoom;
    host.appendChild(zoom);
  }

  /* Variant change → jump Swiper to that variant's image. */
  function bindVariant(list) {
    if (list.__mbVarBound) return;
    list.__mbVarBound = true;
    var section = list.closest('.shopify-section') || document;
    section.addEventListener('change', function (e) {
      if (!list.__mbSwiperInst) return;
      if (e.target && e.target.closest && e.target.closest('variant-selects, variant-radios, .product-form__input')) {
        window.setTimeout(function () {
          var active = list.querySelector('.product__media-item[aria-hidden="false"], .product__media-item.is-active');
          if (active) {
            var idx = active.getAttribute('data-swiper-slide-index');
            if (idx != null) { try { list.__mbSwiperInst.slideToLoop(parseInt(idx, 10)); } catch (e2) {} }
          }
        }, 260);
      }
    });
  }

  /* "Your own words" testimonials → prev/next arrows to scroll the
     native review carousel (.mb-com__slider). */
  function setupTestimonials() {
    document.querySelectorAll('.mb-com__slider').forEach(function (slider) {
      if (slider.__mbComInit) return;
      if (slider.scrollWidth <= slider.clientWidth + 10) return;
      slider.__mbComInit = true;
      var wrap = slider.closest('.mb-com__slider-wrap') || slider.parentElement;
      if (getComputedStyle(wrap).position === 'static') wrap.style.position = 'relative';
      function arrow(cls, label, dPath) {
        var b = document.createElement('button');
        b.type = 'button'; b.className = 'mb-com-nav ' + cls; b.setAttribute('aria-label', label);
        b.innerHTML = '<svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true"><path d="' + dPath + '" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
        return b;
      }
      function step() { var c = slider.querySelector('.mb-com__card, .mb-com__panel'); return (c ? c.getBoundingClientRect().width : 300) + 26; }
      var prev = arrow('mb-com-prev', 'Vorige review', 'M15 5 L8 12 L15 19');
      var next = arrow('mb-com-next', 'Volgende review', 'M9 5 L16 12 L9 19');
      prev.addEventListener('click', function () { slider.scrollBy({ left: -step(), behavior: 'smooth' }); });
      next.addEventListener('click', function () { slider.scrollBy({ left: step(), behavior: 'smooth' }); });
      wrap.appendChild(prev); wrap.appendChild(next);
    });
  }

  /* Lightbox bottom controls (mobile): ‹ prev | ✕ close | › next — three
     white circles centered at the bottom, like the reference. We
     move Dawn's existing close button into the bar (keeps its close handler)
     and add prev/next that scroll the horizontal modal carousel ±1 image. */
  function setupZoomControls() {
    if (!isMobile()) return;
    var dialog = document.querySelector('.product-media-modal__dialog');
    if (!dialog || dialog.__mbControls) return;
    var content = dialog.querySelector('.product-media-modal__content');
    var close = dialog.querySelector('.product-media-modal__toggle');
    if (!content || !close) return;
    dialog.__mbControls = true;
    function arrow(cls, label, d) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mb-zoom-btn ' + cls; b.setAttribute('aria-label', label);
      b.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" aria-hidden="true"><path d="' + d + '" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"/></svg>';
      return b;
    }
    var prev = arrow('mb-zoom-prev', 'Previous image', 'M15 5 L8 12 L15 19');
    var next = arrow('mb-zoom-next', 'Next image', 'M9 5 L16 12 L9 19');
    function step(dir) { var w = content.clientWidth || window.innerWidth; content.scrollBy({ left: dir * w, behavior: 'smooth' }); }
    prev.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(-1); });
    next.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); step(1); });
    close.classList.add('mb-zoom-btn', 'mb-zoom-close');
    var bar = document.createElement('div');
    bar.className = 'mb-zoom-controls';
    bar.appendChild(prev);
    bar.appendChild(close);
    bar.appendChild(next);
    dialog.appendChild(bar);
  }

  /* FIX: opening the zoom from a tap on the gallery leaves Swiper thinking a
     touch is still in progress (the pointerup lands on the modal, not the
     swiper) → after closing the lightbox, horizontal swipe is dead until a
     reload. On modal CLOSE, rebuild the main gallery Swiper (clears the stuck
     touch state + reattaches listeners), preserving the current image. */
  function rebuildMain() {
    document.querySelectorAll('.product__media-list').forEach(function (list) {
      if (!isMobile() || !list.__mbSwiperInst) return;
      var idx = list.__mbSwiperInst.realIndex || 0;
      teardown(list);
      build(list);
      if (list.__mbSwiperInst) { try { list.__mbSwiperInst.slideToLoop(idx, 0); } catch (e) {} }
    });
  }
  function setupModalCloseRebuild() {
    var modal = document.querySelector('product-modal');
    if (!modal || modal.__mbCloseObs || typeof MutationObserver !== 'function') return;
    modal.__mbCloseObs = true;
    var obs = new MutationObserver(function () {
      if (!modal.hasAttribute('open')) { window.setTimeout(rebuildMain, 60); }
    });
    obs.observe(modal, { attributes: true, attributeFilter: ['open'] });
  }

  /* Preload the rest of the PDP gallery in the BACKGROUND after the page is
     idle. Dawn lazy-loads all but the first image, so swiping to the next
     photo fetches it on the spot (visible load delay). Flipping the lazy
     imgs to eager once the page is idle warms the browser cache so swipes
     are instant. fetchpriority=low keeps it from competing with anything. */
  function preloadGallery() {
    var imgs = document.querySelectorAll('.product__media-list .product__media-item img[loading="lazy"]');
    Array.prototype.forEach.call(imgs, function (img) {
      try { img.setAttribute('fetchpriority', 'low'); } catch (e) {}
      img.setAttribute('loading', 'eager');
    });
  }
  function schedulePreload() {
    var go = function () { preloadGallery(); };
    if ('requestIdleCallback' in window) window.requestIdleCallback(go, { timeout: 2500 });
    else window.setTimeout(go, 1200);
  }

  function run() {
    document.querySelectorAll('.product__media-list').forEach(sync);
    setupTestimonials();
  }
  function init() {
    document.querySelectorAll('.product__media-list').forEach(function (l) { bindVariant(l); });
    setupZoomControls();
    setupModalCloseRebuild();
    schedulePreload();
    run();
  }

  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('resize', run);
  document.addEventListener('shopify:section:load', init);

  /* Open the zoom lightbox ON the tapped image. Dawn's showActiveMedia
     forces the modal scrollLeft to ~0 (built for its single-image modal);
     we show all images side-by-side, so scroll the content to the tapped
     media's slide. Re-applied for ~360ms to win against Dawn's reset. */
  document.addEventListener('click', function (e) {
    var tog = e.target.closest && e.target.closest('.product__media-toggle');
    if (!tog) return;
    var mid = tog.getAttribute('data-media-id');
    if (!mid) return;
    var tries = 0;
    var iv = window.setInterval(function () {
      tries++;
      var modal = document.querySelector('product-modal[open]');
      var content = modal && modal.querySelector('.product-media-modal__content');
      var slide = content && content.querySelector('[data-media-id="' + mid + '"]');
      if (slide && content) content.scrollLeft = slide.offsetLeft;
      if (tries > 12) window.clearInterval(iv);
    }, 30);
  }, false);
})();

/* Collection page (vertical filters): the mobile bar sort dropdown
   (#SortBy-mobile-bar) is a custom control Dawn's facets.js doesn't read
   (it only serialises FacetSortForm / FacetFiltersForm). Mirror its value
   into Dawn's desktop sort select (#SortBy) and fire the event Dawn listens
   for, so the existing AJAX sort machinery applies it. Delegated on document
   so it survives facets.js re-rendering the section. */
(function () {
  'use strict';
  document.addEventListener('change', function (e) {
    var t = e.target;
    if (!t || t.id !== 'SortBy-mobile-bar') return;
    var desktop = document.getElementById('SortBy');
    if (desktop && desktop.value !== t.value) {
      desktop.value = t.value;
      desktop.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }, false);
})();

/* Desktop PDP: the vertical thumbnail rail grows to its own content height and
   overshoots the main image. Cap it to the main image height, scroll within,
   and add up/down chevron buttons. Desktop only (>=990px). */
(function () {
  'use strict';
  var DESKTOP = '(min-width: 990px)';
  function isDesktop() { return window.matchMedia(DESKTOP).matches; }
  var SVG_UP = '<svg viewBox="0 0 12 8" aria-hidden="true"><path d="M1 6l5-4 5 4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var SVG_DOWN = '<svg viewBox="0 0 12 8" aria-hidden="true"><path d="M1 2l5 4 5-4" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/></svg>';

  function debounce(fn, ms) { var t; return function () { clearTimeout(t); t = setTimeout(fn, ms); }; }

  function init() {
    var gallery = document.querySelector('media-gallery[data-desktop-layout="thumbnail"]');
    if (!gallery) return;
    var mainMedia = gallery.querySelector('.product__media-list');
    var rail = gallery.querySelector('.thumbnail-slider');
    var list = rail && rail.querySelector('.thumbnail-list');
    if (!mainMedia || !rail || !list) return;

    var up = rail.querySelector('.mb-thumb-chevron--up');
    var down = rail.querySelector('.mb-thumb-chevron--down');

    function step() {
      var t = list.querySelector('.thumbnail-list__item');
      return t ? Math.round(t.getBoundingClientRect().height) + 10 : 80;
    }
    function updateChevrons() {
      if (!up || !down) return;
      var max = list.scrollHeight - list.clientHeight;
      var overflow = max > 4;
      up.hidden = !overflow || list.scrollTop <= 2;
      down.hidden = !overflow || list.scrollTop >= max - 2;
    }
    function sync() {
      if (!isDesktop()) {
        rail.style.height = '';
        list.style.maxHeight = '';
        if (up) up.hidden = true;
        if (down) down.hidden = true;
        return;
      }
      var h = Math.round(mainMedia.getBoundingClientRect().height);
      if (h < 120) return;
      rail.style.height = h + 'px';
      list.style.maxHeight = h + 'px';
      updateChevrons();
    }

    if (!up) {
      up = document.createElement('button');
      up.type = 'button';
      up.className = 'mb-thumb-chevron mb-thumb-chevron--up';
      up.setAttribute('aria-label', 'Scroll thumbnails up');
      up.innerHTML = SVG_UP;
      down = document.createElement('button');
      down.type = 'button';
      down.className = 'mb-thumb-chevron mb-thumb-chevron--down';
      down.setAttribute('aria-label', 'Scroll thumbnails down');
      down.innerHTML = SVG_DOWN;
      rail.appendChild(up);
      rail.appendChild(down);
      up.addEventListener('click', function () { list.scrollBy({ top: -step() * 3, behavior: 'smooth' }); });
      down.addEventListener('click', function () { list.scrollBy({ top: step() * 3, behavior: 'smooth' }); });
      list.addEventListener('scroll', updateChevrons);
    }

    sync();
    var img = mainMedia.querySelector('img');
    if (img && !img.complete) img.addEventListener('load', sync, { once: true });
    window.addEventListener('resize', debounce(sync, 150));
    if (window.ResizeObserver) {
      try { new ResizeObserver(debounce(sync, 60)).observe(mainMedia); } catch (e) {}
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
